import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gap-4 w-full lg:grid lg:grid-cols-2" }

import { Advice } from '@/composables/useAdvices'
import AdvicesListItem from './AdvicesListItem.vue'

type Props = {
    advices: Advice[]
}
interface IEventAdvicesList {
    (e: 'fetchAdvices'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    advices: { type: Array, required: true }
  },
  emits: ["fetchAdvices"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'fetchAdvices'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    advices: Advice[]
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.advices, (advice) => {
      return (_openBlock(), _createBlock(AdvicesListItem, {
        key: advice.id,
        advice: advice,
        onFetchAdvices: _cache[0] || (_cache[0] = ($event: any) => (emit('fetchAdvices')))
      }, null, 8, ["advice"]))
    }), 128))
  ]))
}
}

})